import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: '01',
      title: 'Sign Up & Configure',
      description: 'Create your account, set your communication preferences, and configure your Call, SMS, and Email channels.'
    },
    {
      number: '02',
      title: 'Generate Embed Code',
      description: 'Generate your unique embed code from the web app dashboard — customize button style, agents, and routing rules.'
    },
    {
      number: '03',
      title: 'Paste on Your Website',
      description: 'Copy-paste the embed code into your website. Works with any platform — Shopify, WordPress, Wix, or custom HTML.'
    },
    {
      number: '04',
      title: 'Receive Context-Rich Contacts',
      description: 'Customers connect with one click. Your agents get full context — page, intent, history — before saying hello.'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works-section">
      <div className="section-container">
        <div className="section-header reveal">
          <div className="section-label">How It Works</div>
          <h2 className="section-title">From Embed to Revenue in 4 Steps</h2>
          <p className="section-description">
            A simple, low-code setup gets you from sign-up to live customer interactions in under an hour.
          </p>
        </div>
        
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card reveal">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
